import React from 'react';
import CellBackground from "../CellBackground";
import Coordinates from '../Coordinates/Coordinates';

export default class LeftMenuItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isCollapsed: props.isCollapsed,
        };

        this.handleClick = () => {
            this.setState({ isCollapsed: !this.state.isCollapsed });
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isCollapsed !== this.props.isCollapsed) {
            this.setState({ isCollapsed: this.props.isCollapsed });
        }
    }

    render() {
        return <div id={this.props.category}>
            <h4 className="accordion" style={{ 'fontSize': '0.9rem' }} onClick={this.handleClick}>
                <span>{this.props.category}</span>
                <i className={"fas fa " + (this.state.isCollapsed ? "fa-minus" : "fa-plus")} />
            </h4>
            {this.state.isCollapsed && <div className={"panel-acc"}>
                <div className="py-3 pt-4 disks-container">
                    {this.props.discs.map(disc =>
                        <CellBackground key={disc.path} menu='true' value={disc.path} id={disc.id} />)}
                </div>
                    {this.props.category === "kolorowe kwadraty" && <Coordinates mata={this.props.mata} krazki={this.props.krazki} />}
            </div>}
        </div>;
    };
}



// WEBPACK FOOTER //
// ./src/LeftMenu/LeftMenuItem.js